import React from 'react';
import { withStyles } from '@material-ui/core';
import { Stack } from '@mui/material';
import VFormCard from '../../../Venti-UI-Kit/VForms/VFormCard/VFormCard';
import VTextInput from '../../../Venti-UI-Kit/VInputs/VTextInput/VTextInput';
import VTextArea from '../../../Venti-UI-Kit/VInputs/VTextArea/VTextArea';
import VSelectInput from '../../../Venti-UI-Kit/VInputs/VSelectInput/VSelectInput';
import { useRecommendationListForm } from './hook';
import {
  RECOMMENDATION_LIST_TYPE_OPTIONS,
  RECOMMENDATION_LIST_THEME_OPTIONS,
  RECOMMENDATION_LIST_VISIBILITY_OPTIONS,
  RECOMMENDATION_LIST_TYPE,
  THEME_GRADIENTS,
} from './interfaces';
import VAutocomplete from '../../../Venti-UI-Kit/VAutocomplete/VAutocomplete';
import Button from '../../Buttons/Button/Button';
import VImageUploader from '../../../Venti-UI-Kit/VImageUploader/VImageUploader';
import DraggableList from '../../DraggableList/DraggableList';
import DraggableEventListItem from './DraggableEventListItem/DraggableEventListItem';
import styles from './styles';

const RecommendationListForm = ({ list, classes }) => {
  const {
    formState,
    handleInputChange,
    requiredStates,
    searchEvents,
    handleRemoveEvent,
    handleSubmit,
    handleEventSelect,
    handleDragEnd,
    handleSetEventImage,
  } = useRecommendationListForm(list);

  return (
    <Stack gap={2} alignItems="center" maxWidth={990} width="100%">
      <VFormCard label="Información de la lista" icon="create">
        <Stack direction="row" gap={2}>
          <VSelectInput
            name="type"
            title="Tipo de lista"
            required
            value={formState.type.value}
            options={RECOMMENDATION_LIST_TYPE_OPTIONS}
            onChange={handleInputChange}
            errorMessage={formState.type.error}
            flex={5}
            disabled={!!list}
          />
          <VSelectInput
            name="visibility"
            title="Visibilidad"
            required
            value={formState.visibility.value}
            options={RECOMMENDATION_LIST_VISIBILITY_OPTIONS}
            onChange={handleInputChange}
            errorMessage={formState.visibility.error}
            flex={1}
          />
        </Stack>
        <Stack direction="row" gap={2}>
          <Stack gap={2} flex={1}>
            {requiredStates.title && (
              <VTextInput
                name="title"
                title="Título de la lista"
                required
                onChange={handleInputChange}
                value={formState.title.value}
                errorMessage={formState.title.error}
              />
            )}
            {requiredStates.description && (
              <VTextArea
                name="description"
                title="Descripción"
                required
                minRows={2}
                flex={1}
                onChange={handleInputChange}
                value={formState.description.value}
                errorMessage={formState.description.error}
              />
            )}
          </Stack>
          {requiredStates.image && (
            <VImageUploader
              title="Imagen de la lista"
              required
              name="image"
              width={321}
              height={400}
              imageHeight={1200}
              imageWidth={963}
              initialImageSrc={formState.image.value}
              onChange={handleInputChange}
            />
          )}
        </Stack>
        {requiredStates.theme && (
          <VSelectInput
            name="theme"
            title="Tema"
            required
            onChange={handleInputChange}
            value={formState.theme.value}
            errorMessage={formState.theme.error}
            options={RECOMMENDATION_LIST_THEME_OPTIONS}
          />
        )}
        {formState.theme.value && (
          <Stack
            className={classes.themePreview}
            style={{ background: THEME_GRADIENTS[formState.theme.value] }}
          />
        )}
      </VFormCard>
      <VFormCard label="Eventos de la lista" icon="list">
        <VAutocomplete
          title="Eventos"
          onSelectOption={handleEventSelect}
          searchFunction={searchEvents}
          optionLabelKey="name"
          placeholder="Buscar eventos..."
          noOptionsText="No se encontraron eventos"
          loadingText="Buscando eventos..."
          name="events"
          required
          errorMessage={formState.events.error}
        />
        {formState.events.value.length > 0 && (
          <DraggableList
            items={formState.events.value}
            onDragEnd={handleDragEnd}
            renderItem={({ item }) => (
              <DraggableEventListItem
                event={item}
                onRemoveEvent={handleRemoveEvent}
                hasImage={formState.type.value === RECOMMENDATION_LIST_TYPE.PHOTO_CAROUSEL}
                setEventImage={handleSetEventImage}
              />
            )}
          />
        )}
      </VFormCard>

      <Button
        variant="contained"
        fullwidth={false}
        title={list ? 'Guardar' : 'Crear'}
        onClick={handleSubmit}
      />
    </Stack>
  );
};

export default withStyles(styles)(RecommendationListForm);
